import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-13b7e774"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container w-full h-full" };
const _hoisted_2 = { class: "flex w-full justify-end gap-2" };
import { ref } from 'vue';
import Button from 'primevue/button';
import Modal from '@apparatix/Components/Modal.vue';
import FormSkeleton from '@apparatix/Components/FormSkeleton.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangePasswordModal',
    props: {
        open: { type: Boolean },
        onClose: { type: Function }
    },
    setup(__props) {
        const isLoading = ref(true);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, {
                visible: _ctx.open,
                title: "Change Password",
                position: "top",
                "on-close": _ctx.onClose
            }, {
                body: _withCtx(() => [
                    _withDirectives(_createVNode(FormSkeleton, { rows: 3 }, null, 512), [
                        [_vShow, isLoading.value]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_1, [
                        _createElementVNode("iframe", {
                            src: "/update-password-form",
                            class: "w-full h-full border-none",
                            referrerpolicy: "same-origin",
                            onLoad: _cache[0] || (_cache[0] = ($event) => (isLoading.value = false))
                        }, null, 32)
                    ], 512), [
                        [_vShow, !isLoading.value]
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(Button), {
                            label: "Cancel",
                            class: "reasonable-padding",
                            severity: "secondary",
                            onClick: _ctx.onClose
                        }, null, 8, ["onClick"])
                    ])
                ]),
                _: 1
            }, 8, ["visible", "on-close"]));
        };
    }
});
